import React, { useEffect } from 'react'
import { useHistory } from 'react-router'

import {
  DynamicLoadingPage,
  NotFoundView,
  RouteProps,
  routes,
} from '@sketch/modules-common'

// Hooks
import useUserProfile from 'modules/user/useUserProfile'

// Local Components
import WorkspaceProfileDocument from '../containers/WorkspaceProfileDocument/WorkspaceProfileDocument'

// Types
import { useGetPublicationQuery } from '@sketch/gql-types'

interface PublicationViewProps
  extends RouteProps<'WORKSPACE_PROFILE_DOCUMENT'> {}

const PublicationView = (props: PublicationViewProps) => {
  const { shortUrlName, publicationId } = props.match.params
  const { replace } = useHistory()

  const { data: userData } = useUserProfile()
  const { data, loading, error } = useGetPublicationQuery({
    variables: { identifier: publicationId },
  })

  const user = userData?.me
  const publication = data?.publication
  const profileShortUrlName =
    publication?.share?.workspace?.profile?.shortUrlName

  // Fix the shortUrlName if it doesn't match with the Publication shortUrlName
  // This happens if the admin changed the shortUrlName and users are visiting "old" links
  useEffect(() => {
    if (profileShortUrlName && shortUrlName !== profileShortUrlName) {
      replace({
        pathname: routes.WORKSPACE_PROFILE_DOCUMENT.create({
          shortUrlName: profileShortUrlName,
          publicationId,
        }),
      })
    }
  }, [profileShortUrlName, publicationId, replace, shortUrlName])

  if (loading) {
    return <DynamicLoadingPage />
  }

  if (error || !publication) {
    return <NotFoundView />
  }

  return (
    <WorkspaceProfileDocument
      user={user}
      publication={publication}
      shortUrlName={shortUrlName}
    />
  )
}

export default PublicationView
